var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70924 13.4833V11.5723C5.70924 11.0844 6.10761 10.6889 6.59902 10.6889H8.39538C8.63137 10.6889 8.85769 10.782 9.02456 10.9477C9.19142 11.1133 9.28517 11.338 9.28517 11.5723V13.4833C9.28368 13.6862 9.36379 13.8812 9.50773 14.0251C9.65167 14.169 9.84753 14.25 10.0518 14.25H11.2774C11.8498 14.2515 12.3992 14.0268 12.8045 13.6255C13.2097 13.2242 13.4375 12.6794 13.4375 12.1111V6.66679C13.4375 6.20779 13.2325 5.7724 12.8779 5.47792L8.70877 2.17242C7.98354 1.59285 6.94445 1.61156 6.24087 2.21686L2.16688 5.47792C1.79546 5.76372 1.57347 6.2004 1.5625 6.66679V12.1056C1.5625 13.2899 2.52961 14.25 3.72261 14.25H4.92018C5.34452 14.25 5.68937 13.9101 5.69245 13.4889L5.70924 13.4833Z",
    fill: "url(#paint0_linear_2404_28298)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2404_28298",
    x1: 7.5,
    y1: 14.25,
    x2: 7.5,
    y2: 1.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#570280"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.b5207168c73015e70c759dbc283cd287.svg";
export { ForwardRef as ReactComponent };